import React from "react";
import "./IOSFormatWarning.css";

const IOSFormatWarning = ({ isOpen, fileExtension, onClose }) => {
  if (!isOpen) return null;

  const handleGetApp = () => {
    window.open(
      "https://apps.apple.com/ch/app/remux-video-converter/id1617772720?l=en-GB",
      "_blank",
    );
    onClose();
  };

  return (
    <div className="ios-warning-overlay" onClick={onClose}>
      <div className="ios-warning-modal" onClick={(e) => e.stopPropagation()}>
        {/* آیکون */}
        <div className="ios-warning-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15v-2h2v2h-2zm0-10v6h2V7h-2z"
              fill="currentColor"
            />
          </svg>
        </div>

        {/* عنوان */}
        <h2 className="ios-warning-title">فرمت فایل پشتیبانی نمی‌شود</h2>

        {/* توضیح */}
        <p className="ios-warning-text">
          مرورگر iOS از فرمت <strong>.{fileExtension}</strong> پشتیبانی نمی‌کند.
          برای پخش این فایل، ابتدا باید آن را به فرمت <strong>MP4</strong> تبدیل
          کنید.
        </p>

        {/* راه‌حل */}
        <div className="ios-solution-box">
          <div className="solution-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                fill="currentColor"
              />
            </svg>
          </div>
          <div className="solution-content">
            <p className="solution-title">راه‌حل</p>
            <p className="solution-text">
              از یک برنامه تبدیل فرمت ویدیو استفاده کنید.
              <br />
              برای مثال: <strong>Remux Video Converter</strong>
            </p>
          </div>
        </div>

        {/* دکمه‌ها */}
        <div className="ios-warning-actions">
          <button className="ios-btn primary" onClick={handleGetApp}>
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
            </svg>
            دانلود Converter برای آیفون
          </button>
          <button className="ios-btn secondary" onClick={onClose}>
            متوجه شدم
          </button>
        </div>
      </div>
    </div>
  );
};

export default IOSFormatWarning;
